export function standardMatchAnchors(matchCount: number): number[] {
  if (matchCount <= 1) return [1];
  let anchors = [1, 2];
  while (anchors.length < matchCount) {
    const expandedSize = anchors.length * 2;
    anchors = anchors.flatMap((seed, index) => {
      const partner = expandedSize + 1 - seed;
      return index % 2 === 0 ? [seed, partner] : [partner, seed];
    });
  }
  return anchors;
}

export function standardSeededOrder<T>(items: T[]): T[] {
  const size = items.length;
  if (size < 2 || (size & (size - 1)) !== 0) return [...items];
  return standardMatchAnchors(size / 2)
    .flatMap((anchor) => [items[anchor - 1], items[size - anchor]]);
}

export type PreliminaryTargetEntrant<T> = {
  participant: T | null;
  source: string;
};

/**
 * Mirrors backend next-round generation after real play-ins: direct entrants
 * occupy their seed positions and preliminary winners occupy the remaining
 * lowest-seed lines. In random mode, preserve the source ordering unchanged.
 */
export function orderPreliminaryTargetEntrants<T>(
  directAdvancers: T[],
  preliminaryMatchCount: number,
  rankingMode: boolean,
): PreliminaryTargetEntrant<T>[] {
  const entrants: PreliminaryTargetEntrant<T>[] = [
    ...directAdvancers.map((participant) => ({ participant, source: "" })),
    ...Array.from({ length: preliminaryMatchCount }, (_, index) => ({
      participant: null,
      source: `G M${index + 1}`,
    })),
  ];
  return rankingMode ? standardSeededOrder(entrants) : entrants;
}
